// utils/axiosInstance.js
import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_API}/api`,
  withCredentials: true,
});

axiosInstance.interceptors.request.use((config) => {
	const token = localStorage.getItem('token'); // admin stores in localStorage
	if (token) config.headers.Authorization = `Bearer ${token}`;
	return config;
});

let refreshing = false;
let queue = [];

axiosInstance.interceptors.response.use(
	(res) => res,
	async (error) => {
		const { response, config } = error || {};
		if (response?.status === 401 && !config._retry) {
		config._retry = true;

		if (refreshing) {
			await new Promise((resolve) => queue.push(resolve));
		} else {
			refreshing = true;
			try {
				const { data } = await axios.post(
					`${axiosInstance.defaults.baseURL}/admin/auth/refresh`,
					{},
					{ withCredentials: true }
				);
				const newToken = data?.token;
				if (newToken) localStorage.setItem('token', newToken);
			} finally {
				queue.forEach((r) => r());
				queue = [];
				refreshing = false;
			}
		}

		const token = localStorage.getItem('token');
		if (token) config.headers.Authorization = `Bearer ${token}`;
			return axiosInstance(config);
		}
		return Promise.reject(error);
	}
);

export default axiosInstance;
